import { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { useProjects } from "@/contexts/ProjectContext";
import DashboardLayout from "@/components/dashboard/DashboardLayout";
import PageHeader from "@/components/dashboard/PageHeader";
import StatusBadge from "@/components/dashboard/StatusBadge";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { toast } from "sonner";

export default function BacklinksPage() {
  const { activeProjectId } = useProjects();
  const [rows, setRows] = useState([]);
  const [vocab, setVocab] = useState(null);

  const load = useCallback(async () => {
    if (!activeProjectId) return;
    const { data } = await api.get(`/backlinks/${activeProjectId}`);
    setRows(data);
  }, [activeProjectId]);
  useEffect(() => { load(); }, [load]);
  useEffect(() => {
    if (!activeProjectId) return;
    api.get(`/meta/industry-vocab/${activeProjectId}`).then(({ data }) => setVocab(data));
  }, [activeProjectId]);

  const update = async (id, status) => {
    await api.patch(`/backlinks/${id}`, { status });
    setRows((r) => r.map((x) => x.id === id ? { ...x, status } : x));
    toast.success("Updated");
  };

  return (
    <DashboardLayout>
      <PageHeader
        overline="Authority"
        title="Ethical digital PR queue."
        description={vocab?.outreach_line || "No spam. Just relevant outreach to publications, communities, newsletters, and podcasts in your vertical."}
      />
      <div className="bg-white border border-border rounded-sm overflow-hidden">
        <table className="w-full text-sm" data-testid="backlinks-table">
          <thead className="bg-ivory-100 text-left text-[11px] uppercase tracking-widest text-muted-foreground">
            <tr>
              <th className="px-4 py-3">Domain</th>
              <th className="px-4 py-3">Kind</th>
              <th className="px-4 py-3">Authority</th>
              <th className="px-4 py-3">Relevance</th>
              <th className="px-4 py-3">Pitch angle</th>
              <th className="px-4 py-3">Status</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((b) => (
              <tr key={b.id} className="border-t border-border" data-testid={`backlink-row-${b.id}`}>
                <td className="px-4 py-3 font-mono text-xs">{b.domain}</td>
                <td className="px-4 py-3 text-muted-foreground">{b.kind}</td>
                <td className="px-4 py-3">{b.authority_score}</td>
                <td className="px-4 py-3">{Math.round(b.relevance * 100)}%</td>
                <td className="px-4 py-3 max-w-md text-muted-foreground">{b.outreach_angle}</td>
                <td className="px-4 py-3">
                  <Select value={b.status} onValueChange={(v) => update(b.id, v)}>
                    <SelectTrigger className="w-36 h-8 rounded-sm bg-white" data-testid={`bl-status-${b.id}`}><SelectValue /></SelectTrigger>
                    <SelectContent>
                      {["to_contact", "contacted", "closed"].map((s) => (
                        <SelectItem key={s} value={s}><StatusBadge status={s} /></SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </DashboardLayout>
  );
}
